import { render, staticRenderFns } from "./PaymentUploadExcelFile.vue?vue&type=template&id=be973c04&scoped=true"
import script from "./PaymentUploadExcelFile.vue?vue&type=script&lang=js"
export * from "./PaymentUploadExcelFile.vue?vue&type=script&lang=js"
import style0 from "./PaymentUploadExcelFile.vue?vue&type=style&index=0&id=be973c04&lang=css"
import style1 from "./PaymentUploadExcelFile.vue?vue&type=style&index=1&id=be973c04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be973c04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be973c04')) {
      api.createRecord('be973c04', component.options)
    } else {
      api.reload('be973c04', component.options)
    }
    module.hot.accept("./PaymentUploadExcelFile.vue?vue&type=template&id=be973c04&scoped=true", function () {
      api.rerender('be973c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/online-transaction/components/file/PaymentUploadExcelFile.vue"
export default component.exports